const API_URL = 'https://jcam-backend.onrender.com/api';

export default API_URL;